<div class="tags-tab">
  <p class="tab-state" *ngIf="loading">{{ 'common.loading' | translate }}</p>
  <p class="tab-state error" *ngIf="!loading && error">{{ 'audiences.additionalInfo.tags.error' | translate }}</p>
  <p class="tab-state" *ngIf="!loading && !error && !hasData">{{ 'audiences.additionalInfo.tags.empty' | translate }}</p>

  <ng-container *ngIf="!loading && !error && hasData">
    <div class="tags-tab__target" *ngIf="targetSize != null">
      <span class="tags-tab__target-label">{{ 'audiences.additionalInfo.tags.targetSize' | translate }}</span>
      <span class="tags-tab__target-value">{{ formatNumber(targetSize) }}</span>
    </div>

    <div class="tags-tab__chips" *ngIf="tags.length">
      <span class="chip chip--tag" *ngFor="let tag of tags">{{ tag }}</span>
    </div>
    <p class="tab-state" *ngIf="!tags.length">{{ 'audiences.additionalInfo.tags.noTags' | translate }}</p>
  </ng-container>
</div>
